<template>
  <div class="panel mt-20">
    <div class="filter">
      <el-form
        :model="filter"
        ref="filterForm"
        label-position="left"
        label-width="70px"
      >
        <el-form-item label="关键字" prop="name">
          <el-input
            size="small"
            v-model="filter.name"
            @keyup.enter.native="requestSearch"
            autocomplete="off"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="发布日期" prop="date" v-if="date">
          <el-date-picker
            style="width: 360px"
            v-model="filter.date"
            type="daterange"
            size="small"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div class="mt-10">
        <el-button type="primary" size="small" @click="requestSearch"
          >筛选</el-button
        >
        <el-button size="small" @click="requestSearch('reset')">重置</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    date: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      filter: {
        name: '',
        date: [],
      },
    }
  },
  created() {
    this.filter.name = this.$route.query.name || ''
    this.filter.date = this.$route.query.start_date
      ? [this.$route.query.start_date, this.$route.query.end_date]
      : []
  },
  methods: {
    requestSearch(op = '') {
      if (op == 'reset') {
        this.filter.name = ''
        this.filter.date = []
      }
      this.$emit('search', this.filter)
    },
  },
}
</script>